import { Drawer } from '@mui/material'
import { Button } from '@nextui-org/react'
import { IconLock, IconX } from '@tabler/icons-react';
import React, { Fragment, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { generateValidationSchema } from '../../utils/validationSchema';
import Select from '../../components/Select';
import Input from '../../components/Input';
import TooltipContainer from '../../components/TooltipContainer';

const ChangePassword = ({item, entityForm, inputFields, btnName, header}) => {

    const [open, setOpen] = useState(false);

    const {control, handleSubmit, reset, formState: {errors}, register} = useForm({
        resolver: yupResolver(generateValidationSchema(inputFields))
    });

    const openDrawer =()=>{
        document.body.style.ove1001rflow = 'hidden';
        document.body.style.height = '100vh';
        setOpen(true);
    };

    const closeDrawer =()=>{
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
        setOpen(false);
        reset()
    };

    const onSubmit = async(data)=>{
        const newData = {
            id: item.id,
            ...data
        }
        await entityForm.mutateAsync(newData)
        closeDrawer()
    }
    

  return (
    <Fragment>
        <TooltipContainer color='warning' content='Change Password'>
            <Button onClick={openDrawer} className='bg-[orange] text-white' color='warning' isIconOnly size='sm'>
                <IconLock size={16} />
            </Button> 
        </TooltipContainer>
        <Drawer
        open={open}
        anchor='right'
        onClose={()=>closeDrawer()}
        sx={{
        '& .MuiDrawer-paper': {
        width: '400px',
        maxWidth: '400px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        border: 'none',
        zIndex: 9999
        },
        }}
        >
            <div>
                <div className='flex justify-between font-medium items-center px-6 py-4 gap-3 border-b border-[#E6E6E8]'>
                    <h3>{header}</h3>
                    <button onClick={closeDrawer}>
                        <IconX size="20" />
                    </button>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='p-6 text-[12] flex flex-col gap-[6px]'>
                        {
                            inputFields?.map((item, index)=> {
                                if(item?.type === 'select'){
                                    return (
                                        <Select key={index} register={register} item={item} errors={errors} />
                                    )
                                }
                                return (
                                    <Input key={index} register={register} item={item} errors={errors} />
                                )
                            })
                        }
                        <div className='w-full'>
                            <Button type='submit' className='w-full text-white bg-primary rounded-[7px] font-medium'>{btnName}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </Drawer>
    </Fragment>
  )
}

export default ChangePassword